import { AppHelper } from "../../appHelper.js";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager.js";
import { NotificationHelper } from "../../core/util/notificationHelper.js";
import { AppBaseProps, BaseArticle, CommonApp, Context, Entity } from "../../core/components/commonApp.js";
import { Sheet, SheetEventType } from "../../../siteManagement/sheet.js";
import { Helper } from "../../core/util/helper.js";
import { General } from "../../../siteManagement/general.js";
import { Config as config, Config } from "../../core/config/config.js";
import { WorkPackagePartsGrid, WorkPackagePartsGridProps } from "./workPackagePartsGrid.js";
import { DialogHelper } from "../../core/util/dialogHelper.js";
import { MaterialPriceDiscount } from "../../editArticle/editArticle.js";
import { EnumEntity } from "../../commonInterfaces.js";
import React from "react";
export default class WorkPackageApp extends React.Component<WorkPackageAppProps, WorkPackageAppState> {
    common = new AppHelper();
    workPackagePartsGridOptions: {};
    workPackageCapacityRequirementGridOptions: {};
    workPackageReportsGridOptions: {};
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    deleteEnabled: boolean;
    isDeleted: boolean;
    readOnly: boolean;
    private sheet: Sheet;

    constructor(props: Readonly<WorkPackageAppProps> | WorkPackageAppProps) {
        super(props);
        this.readOnly = props.readOnly;
        this.common.init(this);
        this.initApp();
    }

    workPackageIndividualDataProps = () => {
        return { readonly: this.readOnly }
    }

    private initApp = () => {
        this.sheet = General.Sheet.Manager.getTopMostSheet()
        this.props.context.dataSources = {
            taskMachines: this.props.dataSources.taskMachinesDs
        }
    }

    remove = async () => {
        let isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (!isOk) return;

        if (this.props.context.contextType !== "workPackageTemplate") {
            // man kann darüber nur die Arbeitspaketvorlagen löschen.
            return;
        }

        let result = await HTTPService.post<JsonResultClass<WorkPackageEntity>>(`WorkPackageTemplate/DeleteById?id=${this.props.entity.Id}`);
        if (result.Code === 0) {
            NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.WorkPackage.Msg.Deleted"));
            this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
            if (General.Sheet.Manager.getSheetsCount() > 1) {
                this.common.sheetWrapper.hide();
            } else {
                this.deleteEnabled = false;
                this.isDeleted = true;
                this.props.entity.RecordRight.CanWrite = false;
                this.setState({});
                setTimeout(() => {
                    window.location.href = config.baseUrl + "DynamicSearch/WorkPackageTemplates";
                }, 1000);
            }
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }

    }
    save = async () => {
        if (this.common.validate()) {
            if (this.props.context.standAlone) {
                if (await this.onSave())
                    NotificationHelper.showSuccessMessage(Config.translations.savingSuccessfulMessage);
            }
            else {
                this.common.setEntityDirtyState(false);
                if (await this.onSave()) {
                    NotificationHelper.showSuccessMessage(Config.translations.savingSuccessfulMessage);
                    this.common.sheetWrapper.trigger(SheetEventType.SavedSuccessfully, this.props.entity);
                    this.common.sheetWrapper.hide();
                }
            }
        }
    }

    // noinspection JSUnusedGlobalSymbols
    createWorkPackagePartsGrid = (fieldProps: GridContext) => {
        if (Helper.hasValue(this.props.context.workPackagePartsGridOptions)) {
            const props: WorkPackagePartsGridProps = {
                searchSettings: fieldProps.field.searchSettings,
                customButtonSettings: fieldProps.field.customButtonSettings,
                gridOptions: this.props.context.workPackagePartsGridOptions,
                taskMachines: this.props.dataSources.taskMachinesDs,
                contextType: this.props.context.contextType,
                disabled: fieldProps.disabled,
                entity: this.props.entity,
                doUpdate: (parts) => {
                    this.common.handleFieldChange({ model: "entity.PartRequirements" }, parts);
                },
                doSave: this.onSave,
                doResolveParts: this.onResolveParts
            };

            return <>
                <WorkPackagePartsGrid {...props} />
            </>
        }
        return null;
    }

    private onResolveParts = (parents: PartRequirementsEntity[]): Promise<boolean> => {
        return new Promise<boolean>(async resolve => {
            let url = "WorkPackageTemplate/UnpackAssemblyGroupParts";
            if (this.props.context.contextType !== "workPackageTemplate")
                url = "WorkPackage/UnpackAssemblyGroupParts";
            const assemblyResult = await HTTPService.post<JsonResultClass<WorkPackageEntity>>(`${url}`, { parentParts: parents, workPackageId: this.props.entity.Id });
            if (assemblyResult.Code === 1) {
                NotificationHelper.showErrorMessage(assemblyResult.Message);
                this.common.handlePostSave(false);
                resolve(false);
            }
            else {
                Helper.updateEntity(this.props.entity, assemblyResult.Data);
                this.common.handlePostSave(true);
                resolve(true);
            }
        })
    }

    private onSave = (): Promise<boolean> => {
        return new Promise<boolean>(async resolve => {
            if (!this.props.entity.RecordRight.CanWrite)
                resolve(true);
            else if (this.common.validate()) {
                let result: JsonResultClass<WorkPackageEntity>;
                if (this.props.context.contextType === "workPackageTemplate")
                    result = await HTTPService.post<JsonResultClass<WorkPackageEntity>>("WorkPackageTemplate/Save", this.props.entity);
                else // if (this.props.context.contextType === "workPackage")
                    result = await HTTPService.post<JsonResultClass<WorkPackageEntity>>("RecurringTask/SaveWorkPackage", {
                        taskId: this.props.entity.taskEntity.Id,
                        workPackage: this.props.entity,
                        lockId: this.props.entity.taskEntity.IsId
                    });
                if (result.Code === 0) {
                    if (this.props.entity.IsNew && this.props.context.contextType === "workPackageTemplate")
                        General.Functions.HistoryState.replaceState("WorkPackageTemplate/Edit?id=" + encodeURIComponent(this.props.entity.Id));
                    Helper.updateEntity(this.props.entity, result.Data);

                    //if (Helper.hasValue(result.Data.IsId) && this.lockId == undefined) {
                    //    this.lockId = Helper.keepLockAlive("Lock.ashx", result.Data.IsId, "FST_RECURRING_TASKS", 10000);
                    //}
                    this.common.handlePostSave(true);
                    this.common.sheetWrapper.trigger(SheetEventType.SavedSuccessfully, this.props.entity);
                    resolve(true);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                    this.common.handlePostSave(false);
                    resolve(false);
                }
            }
        })
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        // das hier ist doch eigentlich total überflüssig
        switch (field.model) {
            case "entity.MaschNrToFilter":
                //this.setState({ maschNrToFilter: value });
                break;

        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    handleIsSearchFieldFullObjectModel = () => {
    }

    componentDidMount() {
        this.props.context.workPackagePartsGridOptions = this.workPackagePartsGridOptions;
        this.props.context.workPackageCapacityRequirementGridOptions = this.workPackageCapacityRequirementGridOptions;
        this.props.context.workPackageReportsGridOptions = this.workPackageReportsGridOptions;
    }
    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange, handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel });
        return (<CommonApp {...props} />);
    }
}

export interface WorkPackageAppProps extends AppBaseProps {
    entity: WorkPackageEntity;
    context: WorkPackageAppContext;
    readOnly: boolean;
}

export interface WorkPackageAppContext extends Context {
    standAlone: boolean;
    workPackagePartsGridOptions?: {};
    workPackageCapacityRequirementGridOptions?: {};
    workPackageReportsGridOptions?: {};
    dataSources?: {
        taskMachines?: []
    }
}


interface WorkPackageAppState {
    //maschNrToFilter: string;
}

interface GridContext {
    field: {
        customButtonSettings: {};
        searchSettings: {};
    };
    disabled: boolean;
}
export interface PartRequirementsEntity extends GridArticle {
    CapacityRequirement?: CapacityRequirementEntity;
    CapacityRequirementId: string;
    MaschBezeichnung: string;
    ParentArtikelnummer: string;
    ParentBezeichnung: string;
    LinkedTypeValue: LinkedType;
    IsParent?: boolean;
    LinkedType?: EnumEntity<LinkedType>;
    Changed?: boolean;
    CustomPrices?: boolean;
    MaterialPriceDiscount?: MaterialPriceDiscount;
}
export interface TemplateRequirementsEntity extends Entity {
    Id: string;
    CapacityRequirement?: CapacityRequirementEntity;
    CapacityRequirementId: string;
    Mandatory: boolean;
    MaschBezeichnung: string;
    MaschNr: string;
    TemplateId: string;
    Title: string;
    LinkedTypeValue: LinkedType;
    Remark?: string;
    LinkedType?: EnumEntity<LinkedType>;
}

export interface WorkPackageEntity extends Entity {
    entity: any;
    MaschNrToFilter?: string;
    Id: string;
    Title: string;
    JobDescription: string;
    Description: string;
    AllowCombining: boolean;
    CapacityRequirements: CapacityRequirementEntity[];
    PartRequirements: PartRequirementsEntity[];
    TemplateRequirements: TemplateRequirementsEntity[];
    IsTriggered: boolean;
    taskEntity?: {
        Id: string;
        IsId?: number;
        LockMessage?: string;
    }
}
export enum LinkedType {
    Assignments,
    Projects,
    AssignmentsAndProjects,
}

export interface CapacityRequirementEntity extends Entity {
    Id: string;
    Count: number;
    Hours: number;
    Bezeichnung: string;
    IsGroup: boolean;
    Vorname: string;
    Name: string;
    GrNr: number;
    ResNo: string;
    OldId: string;
    IsNew: boolean;
    PlanningBoardFlagId: string;
    PlanningBoardFlagName: string;
    StartMinutes: number;
    StartMinutesString: string;
}

export interface GridArticle extends BaseArticle {
    Id?: string;
    Seriennr?: string;
    Chargennr?: string;
    Datum: Date;
    Anzahl?: number;
    AnzahlPlMat?: number;
    AnzahlLbMat?: number;
    Epreis?: number;
    Gpreis?: number;
    Kosten?: number;
    Rechnungstext?: string;
    Bemerkung?: string;
    Rabatt?: number;
    EkPreis?: number;
    IsUnpacked?: boolean;
    CanBeUnpacked?: boolean;
    Produkt?: string;
    Maschnr?: string;
    ResolvedFrom?: string;
    Pos?: number;
    Summarized?: boolean;
    IsGuid?: string;
    ResolvedBezeichnung?: string;
    CreateLogin?: string;
    ChangeLogin?: string;
    CreateDate?: Date;
    ChangeDate?: Date;

    Lagerid?: number;
    Lagerplatzid?: number;
}
